import { transform } from 'framer-motion'

export const getPowerRatio = (position: number, maxPosition: number, steps: number) => {
  return Math.round(transform(position, [0, maxPosition], [0, steps]))
}

export const getNearestStep = (position: number, maxPosition: number, steps: number) => {
  return Math.round(transform(position, [0, maxPosition], [0, steps]))
}
